import type { TranslationKeys } from "./en";

export const ru: TranslationKeys = {
  nav: {
    findJobs: "Найти работу",
    cvBuilder: "AI Резюме",
    pricing: "Цены",
    openBot: "Открыть бот",
    signIn: "Войти",
    signOut: "Выйти",
    adminDashboard: "Панель админа",
    admin: "Админ",
    pricingAndPlans: "Тарифы и планы",
    theme: "Тема",
    themeDark: "Тёмная",
    themeLight: "Светлая",
    themeSystem: "Системная",
    support: "Поддержка",
    donate: "Поддержать разработчика",
  },
  hero: {
    badge: "AI подбор в реальном времени",
    badgeFocus: "Worldwide",
    title: "Ваш AI карьерный ассистент",
    titleHighlight: "в Telegram",
    subtitle: "200+ команд. AI-инструменты для CV. Вакансии из 4 источников в реальном времени. Мгновенные уведомления. Всё в Telegram — без установки приложений.",
    cta: "Открыть в Telegram",
    ctaPro: "Обновить до PRO",
    leadMagnet: 'Бесплатный гайд: "Как найти удалённую работу за 14 дней"',
    statCommands: "Команд бота",
    statSources: "Источника",
    statAlerts: "Уведомления",
    statCV: "CV и Карьера",
  },
  features: {
    title: "Всё что нужно, чтобы",
    titleHighlight: "Найти работу мечты",
    subtitle: "На базе AI, создано для удалённых работников по всему миру.",
    aiJobSearch: "AI Поиск работы",
    aiJobSearchDesc: "Агрегация в реальном времени из 100+ источников. Удалённые вакансии по всему миру.",
    smartMatching: "Умный подбор",
    smartMatchingDesc: "AI анализирует ваш профиль, навыки и историю для поиска идеальных вакансий.",
    aiDiagnostics: "AI Диагностика",
    aiDiagnosticsDesc: "Детальный анализ качества CV, конкурентоспособности и соответствия рынку.",
    aiCVFix: "AI Исправление CV",
    aiCVFixDesc: "Автоматические улучшения, ATS оптимизация и адаптация под вакансию.",
    cvGenerator: "Генератор CV",
    cvGeneratorDesc: "Создайте CV с нуля. Поддержка EN, LV, RU с экспортом в PDF/DOCX.",
    euFocus: "Глобальный фокус",
    euFocusDesc: "Специальные фильтры для рабочих разрешений, языков и региональных требований.",
    realtime: "Обновления в реальном времени",
    realtimeDesc: "Живая лента вакансий с мгновенными уведомлениями. Не пропустите подходящую возможность.",
    privacy: "Приватность прежде всего",
    privacyDesc: "Ваши данные в безопасности. Не требуются платные AI кредиты — полностью открытый код.",
  },
  howItWorks: {
    title: "Как",
    titleBrand: "RemoteAI",
    titleEnd: "работает",
    subtitle: "От Telegram до работы мечты за 4 простых шага",
    step1Title: "Откройте Telegram бот",
    step1Desc: "Запустите @RemoteJobsCV_bot в Telegram. Регистрация не нужна — просто нажмите Start.",
    step2Title: "Ищите и фильтруйте",
    step2Desc: "Используйте /jobs, /search или 50+ команд для поиска идеальных удалённых позиций.",
    step3Title: "AI Карьерные инструменты",
    step3Desc: "AI анализ CV, сопроводительные письма, подготовка к интервью — всё в Telegram.",
    step4Title: "Настройте уведомления",
    step4Desc: "Создайте /newalert для мгновенных уведомлений. Обновитесь до PRO для безлимитного доступа.",
  },
  cta: {
    badge: "100% Бесплатно для старта",
    title: "Начните получать вакансии в Telegram прямо сейчас",
    subtitle: "Присоединяйтесь к тысячам профессионалов по всему миру. Просто откройте бота, введите /jobs — и вы в деле.",
    openBot: "Открыть Telegram бот",
    upgradePro: "Обновить до PRO",
  },
  footer: {
    description: "Платформа №1 для поиска удалённой работы на базе AI. Найдите работу мечты с интеллектуальным подбором.",
    product: "Продукт",
    resources: "Ресурсы",
    company: "Компания",
    findJobs: "Найти работу",
    cvBuilder: "Генератор CV",
    aiDiagnostics: "AI Диагностика",
    pricing: "Цены",
    careerTips: "Карьерные советы",
    interviewGuide: "Гайд по интервью",
    cvTemplates: "Шаблоны CV",
    blog: "Блог",
    aboutUs: "О нас",
    supportDeveloper: "Поддержать разработчика",
    privacyPolicy: "Политика конфиденциальности",
    termsOfService: "Условия использования",
    supportTitle: "Поддержать разработчика",
    supportDesc: "Помогите RemoteAI оставаться бесплатным",
    copied: "Скопировано!",
    copyBTC: "Копировать BTC",
    learnMore: "Перейти на страницу поддержки",
    copyright: "© 2024 RemoteAI. Все права защищены.",
    madeFor: "Создано для всех",
  },
  jobs: {
    title: "Найдите свою",
    titleHighlight: "Удалённую работу мечты",
    subtitle: "Агрегация в реальном времени из",
    searchPlaceholder: "Должность, навыки или компания...",
    refresh: "Обновить",
    search: "Поиск",
    region: "Регион:",
    source: "Источник:",
    allLocations: "Все регионы",
    latvia: "Латвия 🇱🇻",
    eu: "ЕС 🇪🇺",
    worldwide: "Весь мир 🌍",
    allSources: "Все источники",
    latestJobs: "Последние удалённые вакансии",
    fetchingJobs: "Загрузка вакансий...",
    jobsFound: "вакансий найдено",
    showing: "Показано",
    of: "из",
    jobs: "вакансий",
    loading: "Загрузка...",
    live: "Онлайн",
    fetchingMultiple: "Загрузка вакансий из нескольких источников...",
    noJobsFound: "Вакансии не найдены",
    noJobsDesc: "Попробуйте изменить фильтры или поисковый запрос.",
    freePlan: "Вы на БЕСПЛАТНОМ плане",
    freeDesc: "Показано {cap} из {total} вакансий. Обновитесь для просмотра всех.",
    upgradePro: "Обновить PRO — $9.99/мес",
    openBot: "Открыть бот",
    allJobs: "Все вакансии",
    aiCVTools: "AI CV инструменты",
    instantAlerts: "Мгновенные уведомления",
    smartMatching: "Умный подбор",
    apply: "Откликнуться",
    prev: "Назад",
    next: "Далее",
    page: "Страница",
  },
  auth: {
    signIn: "Войти",
    signUp: "Регистрация",
    welcomeBack: "С возвращением! Войдите в свой аккаунт.",
    createAccount: "Создайте аккаунт для начала поиска работы.",
    email: "Email",
    password: "Пароль",
    fullName: "Полное имя",
    signingIn: "Входим...",
    creatingAccount: "Создаём аккаунт...",
    forgotPassword: "Забыли пароль?",
    resetPassword: "Сбросить пароль",
    resetDescription: "Введите email и мы отправим ссылку для сброса пароля.",
    sendResetLink: "Отправить ссылку",
    sending: "Отправка...",
    cancel: "Отмена",
    terms: "Продолжая, вы соглашаетесь с Условиями использования и Политикой конфиденциальности.",
    missingFields: "Не заполнены поля",
    fillRequired: "Пожалуйста, заполните все обязательные поля",
    enterEmailPassword: "Введите email и пароль",
    accountExists: "Аккаунт существует",
    accountExistsDesc: "Этот email уже зарегистрирован. Пожалуйста, войдите.",
    accountCreated: "Аккаунт создан!",
    accountCreatedDesc: "Теперь вы можете войти в свой аккаунт.",
    signUpFailed: "Ошибка регистрации",
    invalidCredentials: "Неверные данные",
    invalidCredentialsDesc: "Проверьте email и пароль",
    welcomeBackToast: "С возвращением!",
    signedIn: "Вы успешно вошли.",
    signInFailed: "Ошибка входа",
    emailRequired: "Требуется email",
    emailRequiredDesc: "Пожалуйста, сначала введите email.",
    checkEmail: "Проверьте почту",
    checkEmailDesc: "Ссылка для сброса пароля отправлена на ваш email.",
    resetFailed: "Ошибка сброса",
    somethingWrong: "Что-то пошло не так",
  },
  pricing: {
    badge: "Простые цены",
    title: "Выберите свой",
    titleHighlight: "План",
    subtitle: "Начните бесплатно в Telegram. Оплатите USDT (TRC20) для мгновенной активации — без KYC, минимальные комиссии.",
    free: "Бесплатный",
    freePrice: "$0",
    forever: "навсегда",
    freeDesc: "Начните через Telegram",
    proMonthly: "Pro Месяц",
    proMonthlyPrice: "$9.99",
    perMonth: "/месяц",
    proMonthlyDesc: "Разблокируйте все AI функции",
    proYearly: "Pro Год",
    proYearlyPrice: "$79.99",
    perYear: "/год",
    proYearlyDesc: "Скидка 33% — лучшая цена",
    mostPopular: "Популярный",
    startFree: "Начать бесплатно в Telegram",
    payUSDT: "Оплатить USDT",
    payYearly: "Оплатить за год USDT",
    features: {
      threeResults: "3 результата на поиск",
      basicSearch: "Базовые команды поиска",
      browseAll: "Все источники",
      communitySupport: "Поддержка сообщества",
      unlimitedResults: "Безлимитные результаты",
      advancedFilters: "Расширенные фильтры и сохранённые поиски",
      aiCVAnalysis: "AI Анализ и переписка CV",
      aiCoverLetter: "AI Генератор сопроводительных писем",
      instantAlerts: "Мгновенные уведомления о вакансиях",
      atsChecker: "Проверка ATS Score",
      multiLangCV: "Мультиязычное CV (EN/LV/RU)",
      prioritySupport: "Приоритетная поддержка",
      everythingPro: "Всё из Pro Месяц",
      saveYearly: "Экономия $39.89 в год",
      twelveMonths: "12 месяцев полного доступа",
      earlyAccess: "Ранний доступ к новым функциям",
    },
    notIncluded: {
      advancedFilters: "Расширенные фильтры",
      aiCVTools: "AI CV инструменты",
      instantAlerts: "Мгновенные уведомления",
      unlimitedResults: "Безлимитные результаты",
    },
    referralTitle: "Пригласите друзей — получите PRO бесплатно",
    referralDesc: "Пригласите 3 друзей в бот → получите 7 дней PRO бесплатно! Используйте",
    referralEnd: "в боте для получения уникальной ссылки.",
    usdtTitle: "Оплата USDT (TRC20)",
    usdtDesc: "Мы принимаем <b>USDT на TRON (TRC20)</b> как основной способ оплаты. Минимальные комиссии, быстрые подтверждения и <b>автоматическая верификация</b> — TX hash не нужен.",
    signInRequired: "Требуется вход",
    signInRequiredDesc: "Пожалуйста, войдите для оплаты.",
    copiedToClipboard: "Скопировано в буфер",
    plan: "План",
    amount: "Сумма",
    copy: "Копировать",
    network: "Сеть",
    sendTo: "Отправить USDT на:",
    loadingWallet: "Загрузка адреса кошелька...",
    warningNetwork: "⚠️ Отправляйте ТОЛЬКО через сеть TRON (TRC20). Отправка через другую сеть приведёт к потере средств.",
    autoVerified: "✅ <b>Авто-верификация!</b> После отправки точной суммы ваш платёж будет обнаружен и подтверждён автоматически в течение 2 минут. TX hash не нужен.",
    openBotStatus: "Открыть бот для проверки статуса",
  },
  cvBuilder: {
    badge: "AI Генератор CV",
    title: "Создайте своё",
    titleHighlight: "Идеальное CV",
    titleEnd: "с AI",
    subtitle: "Создавайте, оптимизируйте и экспортируйте профессиональные CV для рынка удалённой работы ЕС. ATS-оптимизация и мультиязычная поддержка.",
    aiGeneration: "AI Генерация",
    atsOptimized: "ATS-Оптимизировано",
    langSupport: "EN, LV, RU поддержка",
    copyExport: "Копирование и экспорт",
    step1: "Загрузка или создание",
    step1Desc: "Начните с нуля или загрузите существующее CV",
    step2: "AI улучшение",
    step2Desc: "AI анализирует и улучшает ваше CV",
    step3: "Просмотр и редактирование",
    step3Desc: "Доработайте результат",
    step4: "Экспорт",
    step4Desc: "Скачайте в нужном формате",
    yourOptimizedCV: "Ваше оптимизированное CV",
    aiEnhanced: "Улучшено AI и готово для ATS",
    copyBtn: "Копировать",
    pdf: "PDF",
    startOver: "Начать заново",
    howToStart: "Как вы хотите начать?",
    uploadExisting: "Загрузить существующее CV",
    uploadExistingDesc: "Загрузите TXT файл или вставьте текст — AI полностью преобразит его.",
    createFromScratch: "Создать с нуля",
    createFromScratchDesc: "Расскажите о своём опыте и навыках — AI создаст профессиональное CV.",
    tellAboutYourself: "Расскажите о себе",
    fullName: "Полное имя",
    desiredPosition: "Желаемая позиция",
    professionalSummary: "Профессиональное резюме",
    professionalSummaryPlaceholder: "Кратко опишите профессиональный опыт, ключевые навыки и что ищете...",
    workExperience: "Опыт работы",
    workExperiencePlaceholder: "Перечислите релевантный опыт работы. AI поможет отформатировать...",
    skillsAndTech: "Навыки и технологии",
    skillsPlaceholder: "Перечислите технические навыки, soft skills, языки, сертификаты...",
    generating: "Генерация...",
    generateAICV: "Создать AI CV",
    atsOptimizedCV: "Будет создано ATS-оптимизированное CV",
    uploadYourCV: "Загрузите ваше CV",
    back: "← Назад",
    notEnoughContent: "Недостаточно контента",
    notEnoughContentDesc: "Пожалуйста, добавьте больше деталей (минимум 50 символов).",
    cvGenerated: "CV создано!",
    cvGeneratedDesc: "Ваше оптимизированное CV готово.",
    generationFailed: "Ошибка генерации",
    copied: "Скопировано!",
    copiedDesc: "CV скопировано в буфер обмена",
    failedCopy: "Ошибка копирования",
    downloaded: "Скачано!",
    downloadedDesc: "CV сохранено как PDF.",
    pdfFailed: "Ошибка экспорта PDF",
    fileLoaded: "Файл загружен!",
    fileLoadedDesc: "Текст вашего CV загружен.",
    unsupportedFormat: "Неподдерживаемый формат",
    unsupportedFormatDesc: "Пожалуйста, загрузите TXT файл или вставьте текст CV.",
  },
  diagnostics: {
    badge: "AI Анализ CV",
    title: "Получите",
    titleHighlight: "Диагностику CV",
    subtitle: "Реальный AI анализ качества CV, совместимости с ATS и персональные советы по улучшению.",
    uploadCV: "Загрузите ваше CV",
    clickToUpload: "Нажмите для загрузки или перетащите",
    txtRecommended: "Рекомендуется формат TXT",
    orPaste: "Или вставьте текст",
    pasteCV: "Вставьте ваше CV",
    pastePlaceholder: "Вставьте содержимое CV здесь... Включите опыт, навыки, образование и достижения.",
    uploadInstead: "Загрузить файл",
    characters: "символов",
    minChars: "Минимум 100 символов",
    analyzingAI: "AI анализирует...",
    analyzeCV: "Анализировать CV",
    atsScoring: "ATS Оценка",
    atsDesc: "Проверка совместимости с ATS",
    keywordAnalysis: "Анализ ключевых слов",
    keywordDesc: "Пропущенные ключевые слова",
    marketFit: "Соответствие рынку",
    marketFitDesc: "Соответствие рынку ЕС",
    aiRecommendations: "AI Рекомендации",
    aiRecommendationsDesc: "Персональные советы",
    overallScore: "Общий ATS балл",
    outOf100: "из 100",
    analyzeAnother: "Анализировать другое CV",
    strengths: "Сильные стороны",
    areasToImprove: "Области для улучшения",
    personalizedImprovements: "Персональные улучшения",
    missingKeywords: "Пропущенные ключевые слова",
    aiAutoFix: "AI Авто-исправление",
    aiAutoFixDesc: "AI перепишет CV со всеми улучшениями",
    rewriting: "Переписываем...",
    fixMyCV: "Исправить CV с помощью AI",
    rewrittenCV: "Переписанное CV",
    rewrittenCVDesc: "Ваша оптимизированная версия",
    cvTooShort: "CV слишком короткое",
    cvTooShortDesc: "Пожалуйста, добавьте больше контента для анализа.",
    analysisComplete: "Анализ завершён!",
    analysisCompleteDesc: "Ваше CV проанализировано AI.",
    analysisFailed: "Ошибка анализа",
    rateLimited: "Превышен лимит",
    rateLimitedDesc: "Слишком много запросов. Попробуйте позже.",
    creditsRequired: "Требуются кредиты",
    creditsRequiredDesc: "Нужны AI кредиты. Обратитесь в поддержку.",
    rewriteComplete: "CV переписано!",
    rewriteCompleteDesc: "Ваше оптимизированное CV готово.",
    rewriteFailed: "Ошибка переписки",
  },
  savedJobs: {
    title: "Сохранённые",
    titleHighlight: "Вакансии",
    subtitle: "Ваши закладки в одном месте.",
    signInToView: "Войдите для просмотра сохранённых вакансий",
    signInDesc: "Создайте аккаунт или войдите, чтобы сохранять вакансии.",
    signIn: "Войти",
    noSavedJobs: "Нет сохранённых вакансий",
    noSavedJobsDesc: "Откройте вакансии и нажмите значок сердца для сохранения.",
    browseJobs: "Смотреть вакансии",
    savedJob: "Сохранённая вакансия",
    savedJobs: "Сохранённых вакансий",
    browseMore: "Больше вакансий",
    saved: "Сохранено",
    apply: "Откликнуться",
  },
  support: {
    title: "Поддержите",
    titleHighlight: "Разработчика",
    subtitle: "Помогите RemoteAI оставаться бесплатным и независимым. Ваша поддержка очень важна! 🙏",
    missionTitle: "🎯 Наша миссия",
    missionP1: "RemoteAI создан, чтобы помочь людям по всему миру находить качественную удалённую работу без шума и спама традиционных сайтов. Мы используем AI для подбора подходящих вакансий и помогаем создать конкурентоспособное CV.",
    missionP2: "Этот проект разрабатывается и поддерживается независимым разработчиком. Ваши пожертвования покрывают серверные расходы, API и позволяют разрабатывать новые функции.",
    btcTitle: "Пожертвовать Bitcoin",
    btcDesc: "Конфиденциальные пожертвования. Без аккаунтов, без отслеживания.",
    btcThankYou: "Каждый сатоши помогает! Спасибо за поддержку open-source разработки.",
    otherWays: "Другие способы помочь",
    shareTwitter: "Поделиться в Twitter",
    starGithub: "Звезда на GitHub",
    tellFriend: "Рассказать другу",
  },
  notFound: {
    title: "404",
    message: "Упс! Страница не найдена",
    goHome: "Вернуться на главную",
  },
  checkout: {
    complete: "Оплата прошла",
    thankYou: "Спасибо за апгрейд. Доступ PRO активируется и появится через мгновение.",
    reference: "Идентификатор:",
    noSession: "Информация о сессии не найдена.",
    browseProJobs: "Смотреть PRO вакансии",
    backToPricing: "Назад к тарифам",
  },
  common: {
    sub_complete: "Оформить подписку",
    close: "Закрыть",
    havePromo: "Есть промокод?",
    inviteFriends: "Пригласите друзей — получите PRO бесплатно",
    inviteDesc: "Пригласите 3 друзей в бот → получите 7 дней PRO бесплатно! Используйте",
    inviteEnd: "в боте, чтобы получить уникальную ссылку.",
    mostPopular: "Самый популярный",
    signInRequired: "Требуется вход",
    signInRequiredSubscribe: "Пожалуйста, войдите, чтобы оформить подписку.",
    current: "Текущий план",
    cancels: "Отменяется",
    renews: "Продлевается",
    on: "—",
    proActive: "PRO активен",
    manageBilling: "Управление подпиской",
    opening: "Открываем...",
    billingError: "Не удалось открыть портал оплаты",
    chooseTitle: "Выберите ваш",
    plan: "План",
    badge: "Простые цены",
    subtitle: "Начните бесплатно в Telegram. Обновитесь картой для мгновенной активации. Отмена в любой момент.",
  },
  langSwitcher: {
    en: "English",
    ru: "Русский",
    lv: "Latviešu",
  },
};

